import React from "react";
import { IUser } from "@interfaces";
import { Outlet } from "react-router";
import { useAuthUser } from "@nubeteck/auth";
import { ContextualInformationCard } from "@nubeteck/prime";

const AccountProfileLayout = () => {
  const user = useAuthUser<IUser>()();

  return (
    <div className="flex flex-column lg:flex-row gap-2 flex-1 h-full">
      <div className="w-full">
        <ContextualInformationCard
          title={user?.FullName ?? ""}
          avatar={{ image: "/avatar-placeholder.webp" }}
          items={[
            { iconName: "at", title: user?.Username ?? "" },
            { iconName: "mail", title: user?.Email ?? "" },
            // { iconName: "calendar", title: Datejs(user?.) },
          ]}
        />
      </div>
      <div className="flex flex-1 h-full">
        <Outlet />
      </div>
    </div>
  );
};

export default AccountProfileLayout;
